import template from './confirmDialog.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdMedia, $mdDialog, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onConfirmDialog((params) => {
          $mdDialog
            .show({
              targetEvent: params?.event,
              locals: {
                alert: params?.alert,
                organizationName: params?.organizationName
              },
              multiple: true,
              template,
              controllerAs: '$ctrl',
              controller(alert, organizationName) {
                const self = this;
                self.alert = alert;
                self.organizationName = organizationName;
                self.name = '';
                self.isOrganizationNameEqual = () => {
                  return self.name.toLowerCase() === self.organizationName.toLowerCase();
                };

                self.confirm = () => {
                  $mdDialog.hide({ status: true });
                };
                self.cancel = () => {
                  $mdDialog.hide({ status: false });
                };
              }
            })
            .then((result) => {
              ctrl.onFinished({ status: result.status });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
